<template>
    <div class="free-delivery">
        <ob1-liens
            :is-mini="true"
            :is-button="true"
            :modal-id="id"
            :text="stockAndDeliveryMention"
            :with-arrow="true"
        />
        <ob1-popin-modal2 :id="id" :aria-labelledby="ariaLabelId">
            <h3 :id="ariaLabelId">
                {{ deliveryModalTitle }}
            </h3>
            <div class="col-12">
                <div class="shop">
                    <div class="d-flex justify-content-between">
                        <h4>{{ shopDeliveryTitle }}</h4>
                        <h4>{{ freeDeliveryLabel }}</h4>
                    </div>
                    <div class="d-flex justify-content-between">
                        <span class="bold" v-html="ecoLabel" />
                        <span class="icon icon-Eco-mode h4 mb-0" aria-hidden="true" />
                    </div>
                    <p v-html="shopDeliveryText" />
                </div>
                <div class="pickup">
                    <div class="d-flex justify-content-between">
                        <h4>{{ pickupDeliveryTitle }}</h4>
                        <h4>{{ freeDeliveryLabel }}</h4>
                    </div>
                    <div class="d-flex justify-content-between">
                        <span class="bold" v-html="ecoLabel" />
                        <span class="icon icon-Eco-mode h4 mb-0" aria-hidden="true" />
                    </div>
                    <p v-html="pickupDeliveryText" />
                </div>
                <div class="otherAddress">
                    <div class="d-flex justify-content-between">
                        <h4>{{ otherAddressTitle }}</h4>
                        <h4>{{ otherAddressDeliveryFees }}</h4>
                    </div>
                    <p v-html="otherAddressText" />
                </div>
                <hr class="separator separator--gray4 my-2">
                <p v-html="ecoLabelMention" />
            </div>
        </ob1-popin-modal2>
    </div>
</template>

<script>
export default {
    props: {
        id: {
            type: String,
            required: true
        },
        stockAndDeliveryMention: {
            type: String,
            required: true
        },
        shopDeliveryTitle: {
            type: String,
            required: true
        },
        shopDeliveryText: {
            type: String,
            required: true
        },
        pickupDeliveryTitle: {
            type: String,
            required: true
        },
        pickupDeliveryText: {
            type: String,
            required: true
        },
        deliveryModalTitle: {
            type: String,
            required: true,
        },
        ecoLabel: {
            type: String,
            required: true,
        },
        ecoLabelMention: {
            type: String,
            required: true,
        },
        otherAddressTitle: {
            type: String,
            required: true,
        },
        otherAddressText: {
            type: String,
            required: true,
        },
        otherAddressDeliveryFees: {
            type: String,
            required: true,
        },
        freeDeliveryLabel: {
            type: String,
            required: true,
        }
    },
    computed: {
        ariaLabelId() {
            return this.id + 'title'
        }
    }
}
</script>
